import { z } from 'zod';

const publishableKey = z
  .string()
  .trim()
  .min(1, { error: 'paymentMethods:stripe.validation.publishableKeyRequired' })
  .max(300, { error: 'paymentMethods:stripe.validation.keyLength' })
  .regex(/^pk_(live|test)_\w{6,}$/, {
    error: 'paymentMethods:stripe.validation.publishableKeyFormat',
  });

export const stripeDirectKeysSchema = z.object({
  secretKey: z
    .string()
    .trim()
    .min(1, { error: 'paymentMethods:stripe.validation.secretKeyRequired' })
    .max(300, { error: 'paymentMethods:stripe.validation.keyLength' })
    .regex(/^(sk|rk)_(live|test)_\w{6,}$/, {
      error: 'paymentMethods:stripe.validation.secretKeyFormat',
    }),
  publishableKey,
  webhookSecret: z
    .string()
    .trim()
    .max(300, { error: 'paymentMethods:stripe.validation.keyLength' })
    .refine((value) => value === '' || /^whsec_\w{6,}$/.test(value), {
      error: 'paymentMethods:stripe.validation.webhookSecretFormat',
    }),
});

export type StripeDirectKeysValues = z.infer<typeof stripeDirectKeysSchema>;

export const stripePublishableKeySchema = z.object({ publishableKey });

export type StripePublishableKeyValues = z.infer<typeof stripePublishableKeySchema>;

/** The backend's ApplePayDomainRequest: a bare host name, lowercase, 3 to 253 characters. */
export const applePayDomainSchema = z.object({
  domain: z
    .string()
    .trim()
    .toLowerCase()
    .min(3, { error: 'paymentMethods:stripe.applePay.validation.domain' })
    .max(253, { error: 'paymentMethods:stripe.applePay.validation.domainLength' })
    .regex(/^[a-z0-9.-]+\.[a-z]{2,}$/, {
      error: 'paymentMethods:stripe.applePay.validation.domain',
    }),
});

export type ApplePayDomainValues = z.infer<typeof applePayDomainSchema>;

export const webhookSecretSchema = z.object({
  webhookSecret: z
    .string()
    .trim()
    .min(1, { error: 'paymentMethods:stripe.webhookSecret.validation.required' })
    .max(300, { error: 'paymentMethods:stripe.validation.keyLength' })
    .regex(/^whsec_\w{6,}$/, { error: 'paymentMethods:stripe.validation.webhookSecretFormat' }),
});

export type WebhookSecretValues = z.infer<typeof webhookSecretSchema>;
